import React from "react";
import Label from "./Label";

const CreditHours = (props) => {
  const key = "credit-hours-key";
  const input = (
    <input
      id={key + "input"}
      type="number"
      value={props.creditHours}
      style={{ width: "4rem", height: "3rem", fontSize: "2rem" }}
      onClick={(e) => props.focus(key, e)}
      onChange={(e) => props.handleChange({ type: "credit_hours" }, e)}
    />
  );
  const display = (
    <div
      className="d-flex justify-content-left md-font"
      onClick={(e) => props.focus(key, e)}
    >
      {props.creditHours}
    </div>
  );
  return (
    <div id={key} className="d-flex flex-row justify-content-left top-buffer">
      <Label text="Credit Hours:" />
      <div className="card inner-buffer">
        {props.focusKey == key ? input : display}
      </div>
    </div>
  );
};

export default CreditHours;
